export const copyToClipboard = (textToCopy: string) => () => {
  // @ts-ignore
  if (window.clipboardData! && window.clipboardData!.setData) {
    // @ts-ignore
    return window.clipboardData!.setData('Text', textToCopy);
  } else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
    const textarea = document.createElement('textarea');
    textarea.textContent = textToCopy;
    textarea.innerText = textToCopy;
    textarea.value = textToCopy;
    textarea.setAttribute('value', textToCopy);
    textarea.style.position = 'fixed';
    document.body.appendChild(textarea);
    textarea.select();
    try {
      navigator.clipboard.writeText(textToCopy);
      return document.execCommand('copy');
    } catch (ex) {
      console.warn('Copy to clipboard failed.', ex);
      return false;
    } finally {
      document.body.removeChild(textarea);
    }
  }
};
